<div class="source-pills-container" *ngIf="groupedSources && groupedSources.length > 0">
  <div class="source-pills-header">
    <div class="header-left">
      <span class="material-icons-outlined">link</span>
      <span>Quellen ({{ groupedSources.length }})</span>
    </div>
    <button 
      *ngIf="showExpandButton" 
      class="expand-button"
      (click)="toggleExpanded()"
      [attr.aria-label]="isExpanded ? 'Quellen einklappen' : 'Alle Quellen anzeigen'"
    >
      <span class="material-icons-outlined">{{ isExpanded ? 'expand_less' : 'expand_more' }}</span>
      <span class="expand-text">{{ isExpanded ? 'Weniger' : 'Alle anzeigen' }}</span>
    </button>
  </div>
  
  <div class="source-pills-wrapper" [class.expanded]="isExpanded" [class.has-more]="showExpandButton">
    <div class="source-pills">
      <div
        *ngFor="let source of visibleSources"
        class="source-pill"
        [class.source-pill--anonymous]="source.anonymous"
        [id]="'source-pill-' + source.refNumbers[0]"
        [attr.data-refs]="source.refNumbers.join(',')"
        (click)="openSource(source)"
        [matTooltip]="source.anonymous ? '' : source.title"
        matTooltipPosition="above"
      >
        <span class="source-pill__refs">{{ formatRefNumbers(source.refNumbers) }}</span>
        <span class="material-icons-outlined source-pill__icon">{{ source.anonymous ? 'lock' : source.icon }}</span>
        <span class="source-pill__title">{{ source.title }}</span>
        <span *ngIf="!source.anonymous" class="material-icons-outlined source-pill__open-icon">open_in_new</span>
      </div>
    </div>
  </div>
</div>
